import { FutureMessage } from '../../interfaces/FutureMessage';
import { removeTags } from '../../utils/removeTags';
import { Dropdown } from 'react-bootstrap';
import { formatDate, formatDateAndTimeTextually } from '../../utils/formatDate';
import React from 'react';
import emailIcon from './email.png';
import whatsappIcon from './whatsapp.png';
import Tooltip from '@mui/material/Tooltip';
import { getBotAvatarContent, getBotAvatarTooltip, getBotDisplayName } from './chatAvatarUtils';

interface UserMessageProps {
    id: string;
    message: FutureMessage;
    onCancelFutureMessage: (message: FutureMessage) => void;
    onSendFutureMessageNow: (message: FutureMessage) => void;
}

const FutureMessageItem = ({ message, onCancelFutureMessage, onSendFutureMessageNow, id }: UserMessageProps) => {
    const renderBody = () => {
        if (!message.body) return;

        if (message.communicationMethod === 'email') {
            return removeTags(message.body)
                ?.split('***')
                .map((line, index) => (
                    <span key={index}>
                        {line}
                        <br />
                    </span>
                ));
        } else {
            return message.body.split('\n').map((line, index) => (
                <span key={index}>
                    {line}
                    <br />
                </span>
            ));
        }
    };

    const getBotName = (message: FutureMessage) => {
        if (message.assignedBot) {
            return message.assignedBot.botName;
        }
        return 'Chatbot';
    };

    const getBotDisplayNameForMessage = (message: FutureMessage) => {
        const botName = getBotName(message);
        const assignedBy = message.assignedBot?.assignedBy;
        const createdAt = message.assignedBot?.createdAt;

        return getBotDisplayName(botName, message.messageId, assignedBy, createdAt);
    };

    return (
        <li className="clearfix" id={id}>
            <div className="chat-avatar position-relative">
                <Tooltip title={getBotAvatarTooltip(message.assignedBot?.assignedBy, message.assignedBot?.createdAt)} arrow>
                    {getBotAvatarContent(message.assignedBot?.assignedBy)}
                </Tooltip>
            </div>

            <div className="conversation-text">
                <div className="ctext-wrap future">
                    {message.assignedBot ? (
                        <div className="sender-name">{getBotDisplayNameForMessage(message)}</div>
                    ) : message.rep ? (
                        <div className="sender-name">{message.rep.fullName}</div>
                    ) : (
                        <div className="sender-name">Chatbot</div>
                    )}

                    <i className="message-status mdi mdi-lock"></i>

                    {renderBody()}

                    <p>
                        <i>{formatDateAndTimeTextually(message.date)}</i>
                    </p>

                    <Dropdown align="start" className="actions">
                        <Dropdown.Toggle as="a" className="btn-sm card-drop cursor-pointer">
                            <i className="mdi mdi-dots-vertical font-16"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => onSendFutureMessageNow(message)}>
                                <span>
                                    Send now
                                    <i className="mdi mdi-send" />
                                </span>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => onCancelFutureMessage(message)}>
                                <span>
                                    Cancel message
                                    <i className="mdi mdi-cancel" />
                                </span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="chat-buttons">
                    {message.buttons?.map((button, index) => (
                        <button key={index} className="btn">
                            {button.text}
                        </button>
                    ))}
                </div>
            </div>
        </li>
    );
};

export default FutureMessageItem;
